import "./rightbar.css";
import Online from "../online/Online";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";

export default function Rightbar({ user }) {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const [followings, setFollowings] = useState([]);
  const [friends, setFriends] = useState([]);
  const { user: currentUser, dispatch } = useContext(AuthContext);
  const [followers, setFollowers] = useState([]);

  useEffect(() => {
    if (window.location.href.includes("/profile/")) {
      (async () => {
        try {
          if (!(user == undefined)) {
            if (Object.keys(user).length > 0) {
              console.log(user)
              const [friendList, followingsList, followersList] = await Promise.all([
                axios.get("https://conexus-api.vercel.app/api/users/friends/" + currentUser._id),
                axios.get("https://conexus-api.vercel.app/api/users/followings/" + user._id),
                axios.get("https://conexus-api.vercel.app/api/users/followers/" + user._id)
              ]);
              setFriends(friendList.data);
              setFollowings(followingsList.data);
              setFollowers(followersList.data)
            }
          }
        } catch (err) {
        }
      })();
    } else {
      (async () => {
        try {
          const friendList = await axios.get("https://conexus-api.vercel.app/api/users/friends/" + currentUser._id);
          const onlineFriendList = friendList.data.filter(friend => friend.isOnline === true)
          setFriends(onlineFriendList);
        } catch (err) {
          console.log(err);
        }
      })();
    }
  }, [user]);

  const handleClick = async () => {
    try {
      if (followers.includes(currentUser._id)) {
        await axios.put(`https://conexus-api.vercel.app/api/users/${user._id}/unfollow`, {
          userId: currentUser._id,
        });
        dispatch({ type: "UNFOLLOW", payload: user._id });
      } else {
        await axios.put(`https://conexus-api.vercel.app/api/users/${user._id}/follow`, {
          userId: currentUser._id,
        });
        dispatch({ type: "FOLLOW", payload: user._id });
      }
      setFollowers(followers.filter(id => id !== currentUser._id));
      window.location.reload()
    } catch (err) {
    }
  };

  const HomeRightbar = () => {
    return (
      <>
        <div className="birthdayContainer">
          <img className="birthdayImg" src={PF + "birthday.png"} alt="" />
          <span className="birthdayText">
            <b>João Pança de Balão</b> and <b>3 other friends</b> have a birhday today.
          </span>
        </div>
        <img className="rightbarAd" src="assets/ad.png" alt="" />
        <h2 className="rightbarTitle">Online Friends</h2>
        <ul className="rightbarFriendList">
          {friends.map((u) => (
            <Online key={u._id} user={u} />
          ))}
        </ul>
      </>
    );
  };
  // console.log(window.location.href.includes("/profile/"))

  const ProfileRightbar = () => {
    return (
      <>
        <div className="rightbarTop">
          {user.username !== currentUser.username && (
            <div className="rightbarFollow">
              <button className="rightbarFollowButton" onClick={handleClick}>
                {followers.includes(currentUser._id) ? "Unfollow" : "Follow"}
                {followers.includes(currentUser._id) ? <Remove /> : <Add />}
              </button>
            </div>
          )}
          <div className="rightbarInfo">
            <h4 className="rightbarTitle">User information</h4>
            <div className="rightbarInfoItem">
              <span className="rightbarInfoKey">City:</span>
              <span className="rightbarInfoValue">{user.city}</span>
            </div>
            <div className="rightbarInfoItem">
              <span className="rightbarInfoKey">From:</span>
              <span className="rightbarInfoValue">{user.from}</span>
            </div>
            <div className="rightbarInfoItem">
              <span className="rightbarInfoKey">Relationship:</span>
              <span className="rightbarInfoValue">
                {user.relationship === 1
                  ? "Single"
                  : user.relationship === 1
                  ? "Married"
                  : "-"}
              </span>
            </div>
          </div>
        </div>
        <h4 className="rightbarTitle">User Followings</h4>
        <div className="rightbarFollowings">
          {followings.map((friend) => (
            <Link
              className="rightbarFollowing"
              to={"/profile/" + friend.username}
              style={{ textDecoration: "none" }}
              key={friend._id}
            >
              <div className="imageContainer">
                <img
                  src={
                    friend.profilePicture
                      ? PF + "person/" + friend.profilePicture
                      : PF + "person/no-avatar.png"
                  }
                  alt=""
                  className="rightbarFollowingImg"
                />
              </div>
              <span className="rightbarFollowingName">{friend.username}</span>
            </Link>
          ))}
        </div>
      </>
    );
  };
  return (
    <div className="rightbar">
      <div className="rightbarWrapper">
        {window.location.href.includes("/profile/") ? <ProfileRightbar /> : <HomeRightbar />}
      </div>
    </div>
  );
}
